import React from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import {
    fontSize,
    Grid,
    MixBlendDifference,
    MixBlendText,
    zIndexes,
} from 'style';

const HeroTextCaseComponent = ({
    title,
    client,
    tag,
    year,
    disableDifferenceEffect,
    color,
}) => {
    return (
        <HeroFront
            id="HeroText"
            disableDifferenceEffect={disableDifferenceEffect}>
            <div className="container-fluid" css={container_css}>
                <div className="row" css={row_css}>
                    <div className="col-xs-12 col-md-8">
                        <HeroText
                            disableDifferenceEffect={disableDifferenceEffect}
                            color={color && color.hex}>
                            <Client>{client}</Client>
                            <Title className="h1">{title}</Title>
                            {/* <Tag>
                {tag}, {year}
              </Tag> */}
                        </HeroText>
                    </div>
                </div>
            </div>
        </HeroFront>
    );
};
const HeroTextWrapperAnim = keyframes`
0%{
  opacity: 0;
  transform: translateY(40px);
}
100%{
  opacity: 1;
  transform: translateY(0px);
}
`;
const container_css = css`
    height: 50%;
    align-self: flex-end;
    margin-bottom: 11vh;
    @media (min-width: 799px) {
        margin-bottom: 11vw;
    }
`;
const row_css = css`
    height: 100%;
`;
const Client = styled.div`
    /* font-size: ${fontSize(15)}; */

    opacity: 0;
    transform: translateY(40px);
    animation: ${HeroTextWrapperAnim} 1s .5s forwards;
    margin-bottom: 2.1rem;
    font-family: 'TomoSlab';
`;
const Title = styled.h1`
    opacity: 0;
    transform: translateY(40px);
    animation: ${HeroTextWrapperAnim} 1s 0.7s forwards;
    font-family: 'TomoSlab';
`;


const HeroText = styled.div`
    color: ${props => (props.disableDifferenceEffect ? props.color : '')};
    ${props => !props.disableDifferenceEffect && MixBlendText({})};
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
`;

const HeroFront = styled.div`
    ${props => !props.disableDifferenceEffect && MixBlendDifference};
    width: 100%;
    height: 100%;
    align-items: flex-end;
    display: flex;
    position: absolute;
    top: 0;
    z-index: ${zIndexes.zHero + 1};
    pointer-events: none;
`;

export default HeroTextCaseComponent;
